import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import AIAssistantModal from './AIAssistantModal';

export default function AIAssistant() {
  const location = useLocation();
  const [show, setShow] = useState(false);

  // 拖动相关状态
  const [position, setPosition] = useState({ 
    x: window.innerWidth - 150, 
    y: window.innerHeight - 150 
  });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  
  const buttonRef = useRef<HTMLDivElement>(null);

  // 拖动处理
  const handleMouseDown = (e: React.MouseEvent) => {
    if (show) return;
    setIsDragging(true);
    setDragStart({
      x: e.clientX - position.x,
      y: e.clientY - position.y
    });
  };

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isDragging) return;
      const newX = e.clientX - dragStart.x;
      const newY = e.clientY - dragStart.y;
      const maxX = window.innerWidth - 120;
      const maxY = window.innerHeight - 120;
      setPosition({
        x: Math.max(0, Math.min(newX, maxX)),
        y: Math.max(0, Math.min(newY, maxY))
      });
    };

    const handleMouseUp = () => setIsDragging(false);

    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, dragStart]);

  // 在 AI 聊天页面不显示浮动按钮
  if (location.pathname.startsWith('/ai-chat')) {
    return null;
  }

  return (
    <>
      <div 
        ref={buttonRef}
        style={{ 
          position: 'fixed', 
          left: `${position.x}px`,
          top: `${position.y}px`,
          zIndex: 99999
        }}
        className={isDragging ? 'cursor-grabbing' : (show ? 'cursor-default' : 'cursor-grab')}
      >
        {/* 浮动按钮 */}
        <div
          onMouseDown={handleMouseDown}
          onClick={() => !isDragging && setShow(!show)}
          className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-500 to-cyan-400 
                     text-white shadow-lg hover:shadow-xl transition-all duration-200
                     flex items-center justify-center group hover:scale-110"
        >
          <i className="ri-robot-2-line text-3xl"></i>
          <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full 
                          animate-pulse border-2 border-white"></div>
        </div>
      </div>

      {/* 弹窗 - 不传 onSubmit，会自动跳转到 AI Chat 页面 */}
      <AIAssistantModal
        show={show}
        onClose={() => setShow(false)}
      />
    </>
  );
}
